import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RemoveUserAuth } from "../store/actions/userAction";
import jwt from "jsonwebtoken";

const LoggedInRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user_auth.token);
  const decodedToken = jwt.decode(token);
  const expiration = decodedToken.exp;
  const now = Math.floor(Date.now() / 1000);
  if (now >= expiration) {
    dispatch(RemoveUserAuth);
  }
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route {...rest} render={(props) => (token ? <Component {...props} /> : <Redirect to="/" />)} />
  );
};

export default LoggedInRoute;
